import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserConfigService } from '@sb/shared/user-config';
import { environment } from 'src/environments/environment';

export const RATE_LIMIT_BYPASS_ENABLED_KEY = 'devToolsRateLimitBypassEnabled';

@Injectable()
export class RateLimitBypassInterceptor implements HttpInterceptor {
  #userConfig = inject(UserConfigService);

  #enabled = this.#userConfig.get(RATE_LIMIT_BYPASS_ENABLED_KEY, false);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    // Scoped to our own API so the secret is never sent to third-party hosts
    if (!request.url.startsWith('/api/')) {
      return next.handle(request);
    }

    const secret = environment.rateLimitBypassSecret;

    if (!this.#enabled() || !secret) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'X-RateLimit-Bypass': secret,
        },
      }),
    );
  }
}
